import React, { useContext, useState } from 'react';
import { Auth } from 'aws-amplify';
import classNames from 'classnames';

import { AuthenticatorContext } from './AuthenticatorContext';
import {
   AuthenticatorButton,
   AuthenticatorForm,
   AuthenticatorInput,
   AuthenticatorSubmitButton,
} from './AuthenticatorForm';

const ResendCode = () => {
   const {
      state: { userData },
      dispatch,
   } = useContext(AuthenticatorContext);
   const [loading, setLoading] = useState(false);

   return (
      <AuthenticatorButton
         className={classNames('button-link', { 'button-loading': loading })}
         disabled={loading || undefined}
         onClick={() => {
            setLoading(true);
            dispatch({
               type: 'clearMessage',
            });
            Auth.resendSignUp(userData.email)
               .then(() => {
                  dispatch({
                     type: 'setMessage',
                     successMessage: 'A new code has been sent to your email.',
                  });
               })
               .catch((err) => {
                  dispatch({
                     type: 'setMessage',
                     errorMessage:
                        err?.message || 'An unexpected error ocurred.',
                  });
               })
               .finally(() => setLoading(false));
         }}
      >
         Resend Code
      </AuthenticatorButton>
   );
};

const ConfirmSignUp = () => {
   const {
      state: { userData },
      dispatch,
   } = useContext(AuthenticatorContext);
   return (
      <AuthenticatorForm
         heading="Confirm Sign Up"
         onSubmit={(formData) =>
            Auth.confirmSignUp(userData.email, formData.get('code')).then(
               () => {
                  if (userData.password == null) {
                     dispatch({
                        type: 'changeView',
                        view: 'logIn',
                     });
                  } else {
                     Auth.signIn(userData.email, userData.password);
                  }
               }
            )
         }
      >
         <AuthenticatorInput
            name="email"
            type="email"
            autoComplete="email"
            placeholder="Email"
            value={userData.email}
            readOnly
            required
         />
         <AuthenticatorInput
            name="code"
            autoComplete="one-time-code"
            placeholder="Confirmation Code"
            required
            autoFocus
         />
         <AuthenticatorSubmitButton>Confirm Sign Up</AuthenticatorSubmitButton>
         <p>
            A confirmation code has been sent to your email. Didn&apos;t get a
            code? <ResendCode />
         </p>
      </AuthenticatorForm>
   );
};

export { ConfirmSignUp };
